import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `FichaVerraco/addNuevaAlimentacion`, method: 'POST', body: values, token: token})
}
